import IndexComponent from "../components/indexcomponents/indexcomponent";

const IndexPage = () => {
  return <IndexComponent />;
};

export default IndexPage;
